import { useEffect } from "react";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route, useParams, useLocation } from "react-router-dom";
import "@/App.css";
import { Nav } from "@/components/Nav";
import { Hero } from "@/components/Hero";
import { Urgence } from "@/components/Urgence";
import { Marquee } from "@/components/Marquee";
import { Manifesto } from "@/components/Manifesto";
import { MaitreHotel } from "@/components/MaitreHotel";
import { Services } from "@/components/Services";
import { Tarifs } from "@/components/Tarifs";
import { Gallery } from "@/components/Gallery";
import { Video } from "@/components/Video";
import { Zone } from "@/components/Zone";
import { Temoignages } from "@/components/Temoignages";
import { Faq } from "@/components/Faq";
import { QuoteForm } from "@/components/QuoteForm";
import { Footer } from "@/components/Footer";
import { WhatsAppFloat } from "@/components/WhatsAppFloat";
import CarteVisite from "@/pages/CarteVisite";
import Flyer from "@/pages/Flyer";
import ModeleDevis from "@/pages/ModeleDevis";
import Facture from "@/pages/Facture";
import Espace from "@/pages/Espace";
import SoireeVip from "@/pages/SoireeVip";
import Billet from "@/pages/Billet";
import Verifier from "@/pages/Verifier";
import AfficheVip from "@/pages/AfficheVip";
import AffichesFK from "@/pages/AffichesFK";
import { EventBanner } from "@/components/EventBanner";

const API = process.env.REACT_APP_BACKEND_URL;

const DevisPdfRedirect = () => {
  const { file } = useParams();
  useEffect(() => {
    window.location.replace(`/api/devis-pdf/${file}`);
  }, [file]);
  return null;
};

const Tracker = () => {
  const location = useLocation();
  useEffect(() => {
    if (location.pathname.startsWith("/espace")) return;
    let sid = localStorage.getItem("fk_sid");
    if (!sid) {
      sid = (crypto.randomUUID && crypto.randomUUID()) || String(Date.now()) + Math.random();
      localStorage.setItem("fk_sid", sid);
    }
    fetch(`${API}/api/track`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ path: location.pathname, session_id: sid }),
    }).catch(() => {});
  }, [location.pathname]);
  return null;
};

const Home = () => (
  <div className="bg-[#0a0a0a] text-white" data-testid="fk-app">
    <EventBanner />
    <Nav />
    <main>
      <Hero />
      <Urgence />
      <QuoteForm />
      <Marquee />
      <Manifesto />
      <MaitreHotel />
      <Services />
      <Tarifs />
      <Gallery />
      <Video />
      <Zone />
      <Temoignages />
      <Faq />
    </main>
    <Footer />
    <WhatsAppFloat />
  </div>
);

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09 });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <BrowserRouter>
      <Tracker />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/carte-de-visite" element={<CarteVisite />} />
        <Route path="/flyer" element={<Flyer />} />
        <Route path="/modele-devis" element={<ModeleDevis />} />
        <Route path="/facture" element={<Facture />} />
        <Route path="/espace" element={<Espace />} />
        <Route path="/soiree-vip" element={<SoireeVip />} />
        <Route path="/billet/:numero" element={<Billet />} />
        <Route path="/verifier/:numero/:token" element={<Verifier />} />
        <Route path="/affiche-vip" element={<AfficheVip />} />
        <Route path="/affiches-fk" element={<AffichesFK />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
